import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";
import { ResidentialAddressType } from "@common/utils/graphql";

type UserState = {
  firstName: string | null;
  lastName: string | null;
  workEmail: string | null;
  personalEmail: string | null;
  isBankAccountLinked: boolean;
  residentialAddress: ResidentialAddressType | null;
  userId: string | null;
  employeeId: string | null;
  displayName: string | null;
  departmentId: number | null;
  cardApplicationPageUrl: string | null;
  homePageCardImageUrl: string | null;
  organizationName: string | null;
  organizationId: string | null;
};

type UserStore = UserState & {
  setUser: (user: UserState) => void;
  setIsBankAccountLinked: (isBankAccountLinked: boolean) => void;
  clear: () => void;
};

export const useUserStore = create<UserStore>()(
  devtools(
    persist(
      (set) => ({
        firstName: null,
        lastName: null,
        workEmail: null,
        personalEmail: null,
        isBankAccountLinked: false,
        residentialAddress: null,
        userId: null,
        displayName: null,
        employeeId: null,
        departmentId: null,
        cardApplicationPageUrl: null,
        homePageCardImageUrl: null,
        organizationName: null,
        organizationId: null,
        setUser: (user: UserState) => set(user),
        setIsBankAccountLinked: (isBankAccountLinked: boolean) =>
          set({ isBankAccountLinked }),
        clear: () =>
          set({
            firstName: null,
            lastName: null,
            workEmail: null,
            personalEmail: null,
            isBankAccountLinked: false,
            residentialAddress: null,
            userId: null,
            displayName: null,
            employeeId: null,
            departmentId: null,
            cardApplicationPageUrl: null,
            homePageCardImageUrl: null,
            organizationName: null,
            organizationId: null,
          }),
      }),
      {
        name: "user-storage",
      },
    ),
  ),
);
